const AUTHTOKEN_LOGOUT = "AUTHTOKEN_LOGOUT";
const SITES_REQUEST = "SITES_REQUEST";
const SITE_UPDATE = "SITE_UPDATE";
const SITE_PUT_SUCCESS = "SITE_PUT_SUCCESS";
const SITE_UPDATE_ERROR = "SITE_UPDATE_ERROR";
const SITES_SERVICES_REQUEST = "SITES_SERVICES_REQUEST";
const SITES_SERVICES_SUCCESS = "SITES_SERVICES_SUCCESS";
const SITES_SERVICES_ERROR = "SITES_SERVICES_ERROR";
const SITES_SERVICES_FAKE = "SITES_SERVICES_FAKE";
const SITES_ERROR = "SITES_ERROR";
const SITES_SUCCESS = "SITES_SUCCESS";
const USERS_ITEMS_NEEDING_ATTENTION = "USERS_ITEMS_NEEDING_ATTENTION";
const SITE_CREATE = "SITE_CREATE";
const SITE_CREATE_SUCCESS = "SITE_CREATE_SUCCESS";
const SITE_CREATE_ERROR = "SITE_CREATE_ERROR";
const SITE_ACCESS_CREATE= "SITE_ACCESS_CREATE";
const SITE_ACCESS_CREATE_ERROR = "SITE_ACCESS_CREATE_ERROR";
const SITE_ACCESS_CREATE_SUCCESS = "SITE_ACCESS_CREATE_SUCCESS";
const SITE_ACCESS_FORM = "SITE_ACCESS_FORM";
const SITE_ACCESS_FORM_ERROR = "SITE_ACCESS_FORM_ERROR";
const SITE_ACCESS_FORM_SUCCESS = "SITE_ACCESS_FORM_SUCCESS";
const SITE_CHECKINS_REQUEST = "SITE_CHECKINS_REQUEST";
const SITE_CHECKINS_ERROR = "SITE_CHECKINS_ERROR";
const SITE_CHECKINS_SUCCESS = "SITE_CHECKINS_SUCCESS";
const SITE_CHECKIN_USER = "SITE_CHECKIN_USER";
const SITE_CHECKOUT_USER = "SITE_CHECKOUT_USER";
const SITE_CHECKINS_REQUEST_ALL = "SITE_CHECKINS_REQUEST_ALL";
const SITE_CHECKINS_REQUEST_ALL_SUCCESS = "SITE_CHECKINS_REQUEST_ALL_SUCCESS";
const SITE_CHECKINS_REQUEST_ALL_ERROR = "SITE_CHECKINS_REQUEST_ALL_ERROR";
const SITE_DELETE_REQUEST = "SITE_DELETE_REQUEST";
const SITE_DELETE_SUCCESS = "SITE_DELETE_SUCCESS";
const SITE_DELETE_ERROR = "SITE_DELETE_ERROR";
const SITE_INSPECTION_REQUEST = 'SITE_INSPECTION_REQUEST';
const SITE_INSPECTION_SUCCESS = 'SITE_INSPECTION_SUCCESS';
const SITE_INSPECTION_ERROR = 'SITE_INSPECTION_ERROR';
const SITE_PHOTOS_REQUEST = 'SITE_PHOTOS_REQUEST';
const SITE_PHOTOS_SUCCESS = 'SITE_PHOTOS_SUCCESS';
const SITE_PHOTOS_ERROR = 'SITE_PHOTOS_ERROR';

const SITE_PHOTO_UPLOAD_ADD = 'SITE_PHOTO_UPLOAD_ADD';
const SITE_PHOTO_UPLOAD_UPDATE = 'SITE_PHOTO_UPLOAD_UPDATE';
const SITE_PHOTO_UPLOAD_REMOVE = 'SITE_PHOTO_UPLOAD_REMOVE';

export const PHOTO_UPLOAD_STATUS = {
    PENDING: 'pending',
    UPLOADING: 'uploading',
    SUCCESS: 'success',
    ERROR: 'error'
};

import Vue from "vue";

const state = { 
    status: "", 
    siteservicesstatus: "", 
    sites: null, 
    sitecheckins: null, 
    sitePhotos: {},
    photoUploads: [],
    siteTypes: [
        {
            value: 1,
            type: 'Customer',
            colour: '#207a80'
        },
        {
            value: 2,
            type: 'VPLS',
            colour: '#7a4b9b'
        },
        {
            value: 3,
            type: 'Internet',
            colour: '#9b4b4b'
        },
        {
            value: 4,
            type: 'L3VPN',
            colour: '#9b4b4b'
        },
        {
            value: 5,
            type: 'Interconnects',
            colour: '#207a80'
        }
    ]
};

const getters = {
    getSitesList: state => state.sites === null ? [] : state.sites,
    isSitesListLoaded: state => !!state.sites,
    getSite: (state) => (siteId) => {
        return (state.sites === null ? {} : state.sites.find(site => site.siteid === siteId))
    },
    getSiteType: (state) => (sitetype) => {
        return (state.siteTypes.find(thisSiteType => thisSiteType.value === sitetype))
    },
    getChildSites: (state) => (siteID) => {
        return (state.sites === null ? [] : state.sites.filter(site => {
            return (site.parentsite === siteID && site.sitetype == 1)
        }))
    },
    getSiteByNumber: (state) => (siteNumber) => {
        return (state.sites === null ? {} : state.sites.find(site => site.sitenumber === siteNumber))
    },
    getPhysicalSitesList: (state) => {
        return (state.sites === null ? [] : state.sites.filter(site => site.sitetype == 1))
    },
    getVLANSites: (state) => {
    //    window.console.log("Found Sites: " + JSON.stringify(state.sites.filter(site => site.sitenumber.substring(0, 2) == 'S9')) + " -TEST")
        return (state.sites === null ? [] : state.sites.filter(site => site.sitetype == 2))
    },
    getPhysicalSitesByCustomerUUIDList: (state) => (customerUUID) => {
        return (state.sites === null ? [] : state.sites.filter(site => {
            return (site.customerid === customerUUID && site.sitetype == 1)
        }))
    },
    getAllSitesByCustomerUUIDList: (state) => (customerUUID) => {
        return (state.sites === null ? [] : state.sites.filter(site => {
            return site.customerid === customerUUID && site.sitenumber.substring(0, 2)
        }))
    },
    searchSites: (state) => searchParam => {
        var searchTerm = new RegExp(searchParam, "i")
        return (state.sites === null ? [] : state.sites.filter((site => searchTerm.test(site.sitenumber) || searchTerm.test(site.sitename) || searchTerm.test(site.street))))
    },
    getSiteCheckins: (state) => siteid => {
        return (state.sitecheckins === null ? [] : state.sitecheckins.filter(checkin => checkin.siteid === siteid))
    },
    getPhotoUploads: (state) => state.photoUploads,
    getActivePhotoUploads: (state) => state.photoUploads.filter(p => p.status === PHOTO_UPLOAD_STATUS.PENDING || p.status === PHOTO_UPLOAD_STATUS.UPLOADING),
    getErrorPhotoUploads: (state) => state.photoUploads.filter(p => p.status === PHOTO_UPLOAD_STATUS.ERROR),
    getSiteCheckinList: state => state.sitecheckins === null ? [] : state.sitecheckins,
    getSitePhotos: (state) => (siteid) => {
        return state.sitePhotos[siteid] || [];
    },
    getUserCheckins: (state) => userid => {
        return (state.sitecheckins === null ? [] : state.sitecheckins.filter(checkin => checkin.userid === userid))
    },
    getSiteSelectionList: (state) => {
            //Populate site selection Select and Multiselect lists
            if (state.sites == null) {
                return [];
            }
            let getSites = state.sites;
            let sitesList = [];

            for (let i = 0; i < getSites.length; i++) {
                if (Object.keys(getSites[i]).includes('status') && getSites[i].status == 0) {
                    //Skips inactive sites
                    continue;
                }
                let thisSite = { sitenumber: '', sitename: '', siteid: '' };
                thisSite.sitenumber = getSites[i].sitenumber.substring(1);
                thisSite.sitename = getSites[i].sitenumber + ': ' + getSites[i].sitename;
                thisSite.siteid = getSites[i].siteid;
                thisSite.sitetype = getSites[i].sitetype;
                sitesList.push(thisSite);
            }
            return sitesList;
        }
};

const actions = {
    [SITES_REQUEST]: ({ commit, dispatch }) => {
        return new Promise((resolve, reject) => {
            commit(SITES_REQUEST);
            commit('addLoading', {handle:'sites',name:'Load Sites'})

            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                //body: JSON.stringify(payload)
            };
                            
            fetch(Vue.prototype.$apiServer + 'sites', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                    commit('removeLoading', 'sites')
                        if (resp.result === 'Success') {
                        commit(SITES_SUCCESS, resp)
                        resolve(resp)
                        } else {
                            commit(SITES_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(SITES_ERROR);
                    commit('removeLoading', 'sites')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })        
                }
            })
        })
    },
    [SITE_UPDATE]: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit(SITE_UPDATE);
            commit('addLoading', {handle:'siteupdate',name:'Update Site'})

            let loginDetails = {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                body: JSON.stringify(payload.thisSite)
            };
                            
            fetch(Vue.prototype.$apiServer + 'site/' + payload.siteID, loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                    commit('removeLoading', 'siteupdate')
                    if (resp.result === 'Success') {
                        commit(SITE_PUT_SUCCESS, resp)
                        dispatch(SITES_REQUEST);
                        resolve(resp)
                        dispatch(USERS_ITEMS_NEEDING_ATTENTION)
                    } else {
                        commit(SITE_UPDATE_ERROR)
                        reject(resp)
                    }
                    })
                } else { //Error
                    commit(SITE_UPDATE_ERROR);
                    commit('removeLoading', 'siteupdate')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })        
                }
            }) 
        })
    },
    [SITE_DELETE_REQUEST]: ({ commit, dispatch }, siteid) => {
        return new Promise((resolve, reject) => {
            commit(SITE_DELETE_REQUEST);
            commit('addLoading', {handle:'sitedelete',name:'Deleting Site'})


            
            let loginDetails = {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                //body: JSON.stringify(payload)
            };
                            
            fetch(Vue.prototype.$apiServer + 'site/' + siteid, loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                    commit('removeLoading', 'sitedelete')
                    if (resp.result === 'Success') {
                        commit(SITE_DELETE_SUCCESS, resp)
                        dispatch(SITES_REQUEST);
                        resolve(resp)
                        dispatch(USERS_ITEMS_NEEDING_ATTENTION)
                        } else {
                            commit(SITE_DELETE_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(SITE_UPDATE_ERROR);
                    commit('removeLoading', 'sitedelete')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })        
                }
            })
        })
    },
    [SITE_ACCESS_CREATE]: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit(SITE_ACCESS_CREATE);
            commit('addLoading', {handle:'siteaccess',name:'Submitting Site Access'})


            let loginDetails = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                body: JSON.stringify(payload)
            };
                            
            fetch(Vue.prototype.$apiServer + 'site/' + payload.siteID + "/access", loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                    commit('removeLoading', 'siteaccess')
                        if (resp.result === 'Success') {
                            commit(SITE_ACCESS_CREATE_SUCCESS);
                            resolve(resp)
                        } else {
                            commit(SITE_ACCESS_CREATE_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(SITE_ACCESS_CREATE_ERROR);
                    commit('removeLoading', 'siteaccess')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })        
                }
            })
        })
    },
    [SITE_ACCESS_FORM]: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit(SITE_ACCESS_FORM);
            commit('addLoading', {handle:'siteaccessform',name:'Submitting Site Access Form'})

            let loginDetails = {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                body: JSON.stringify(payload)
            };
                            
            fetch(Vue.prototype.$apiServer + 'site/' + payload.siteID + "/access/form", loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                    commit('removeLoading', 'siteaccessform')
                        if (resp.result === 'Success') {
                            commit(SITE_ACCESS_FORM_SUCCESS);
                            resolve(resp)
                        } else {
                            commit(SITE_ACCESS_FORM_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(SITE_ACCESS_FORM_ERROR);
                    commit('removeLoading', 'siteaccessform')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })        
                }
            })
        })
    },
    [SITES_SERVICES_REQUEST]: ({ commit, dispatch }, siteid) => {
        return new Promise((resolve, reject) => {
            commit(SITES_SERVICES_REQUEST);
            commit('addLoading', {handle:'siteservices',name:'Load Site Services'})


            let loginDetails = {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload)
            };
                            
            fetch(Vue.prototype.$apiServer + 'site/' + siteid + '/services', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                    commit('removeLoading', 'siteservices')
                        if (resp.result === 'Success') {
                            commit(SITES_SERVICES_SUCCESS, {"siteid": siteid, "response": resp.payload.services});
                            dispatch(SITES_REQUEST);
                            resolve(resp)
                        } else {
                            commit(SITES_SERVICES_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(SITES_SERVICES_ERROR);
                    commit('removeLoading', 'siteservices')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })        
                }
            })
        })
    },
    [SITE_CREATE]: ({ commit, dispatch }, payload) => {
    //    window.console.log("New Site Payload: " + JSON.stringify(payload))
        return new Promise((resolve, reject) => {
            commit(SITE_CREATE);
            commit('addLoading', {handle:'sitecreate',name:'Creating New Site'})


            let loginDetails = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                body: JSON.stringify(payload)
            };
                            
            fetch(Vue.prototype.$apiServer + 'site', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                    commit('removeLoading', 'sitecreate')
                        if (resp.result === 'Success') {
                            commit(SITE_CREATE_SUCCESS, resp);
                            dispatch(SITES_REQUEST);
                            resolve(resp)
                            dispatch(USERS_ITEMS_NEEDING_ATTENTION)
                        } else {
                            commit(SITE_CREATE_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(SITE_CREATE_ERROR);
                    commit('removeLoading', 'sitecreate')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })        
                }
            })
        })
    },
    [SITE_CHECKINS_REQUEST_ALL]: ({ commit, dispatch }) => {
        return new Promise((resolve, reject) => {
            commit(SITE_CHECKINS_REQUEST_ALL);
            commit('addLoading', {handle:'sitesallcheckins',name:'Loading Site Check-Ins'})

            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload)
            };
            
            fetch(Vue.prototype.$apiServer + 'checkins', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                    commit('removeLoading', 'sitesallcheckins')
                        if (resp.result === 'Success') {
                            commit(SITE_CHECKINS_REQUEST_ALL_SUCCESS, resp);
                            resolve(resp)
                        } else {
                            commit(SITE_CHECKINS_REQUEST_ALL_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(SITE_CHECKINS_REQUEST_ALL_ERROR);
                    commit('removeLoading', 'sitesallcheckins')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })        
                }
            })
        })
    },
    [SITE_CHECKINS_REQUEST]: ({commit, dispatch}, siteid) => {
        return new Promise((resolve, reject) => {
            commit(SITE_CHECKINS_REQUEST);
            commit('addLoading', {handle: 'getcheckins'+siteid, name: 'Loading Site Checkin List'})


            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload)
            };
                            
            fetch(Vue.prototype.$apiServer + 'site/'+siteid + '/checkins', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                    commit('removeLoading', 'getcheckins'+siteid)
                        if (resp.result === 'Success') {
                            commit(SITE_CHECKINS_SUCCESS);
                            resolve(resp.payload)
                        } else {
                            commit(SITE_CHECKINS_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(SITE_CHECKINS_ERROR);
                    commit('removeLoading', 'getcheckins'+siteid)
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })        
                }
            })
        })
    },
    [SITE_CHECKIN_USER]: ({ commit, dispatch }, payload) => {
        //    window.console.log("New Site Payload: " + JSON.stringify(payload))
        return new Promise((resolve, reject) => {
            commit(SITE_CHECKIN_USER);
            commit('addLoading', {handle:'checkinSite',name:'Checking into Site'})


            let loginDetails = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                body: JSON.stringify(payload)
            };
                            
            fetch(Vue.prototype.$apiServer + 'site/' + payload.siteid + '/checkin', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                    commit('removeLoading', 'checkinSite')
                        if (resp.result === 'Success') {
                            commit(SITE_CHECKINS_SUCCESS);
                            resolve(resp)
                        } else {
                            commit(SITE_CHECKINS_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(SITE_CHECKINS_ERROR);
                    commit('removeLoading', 'checkinSite')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })        
                }
            })
        })
    },
    [SITE_CHECKOUT_USER]: ({ commit, dispatch }, payload) => {
        //    window.console.log("New Site Payload: " + JSON.stringify(payload))
        return new Promise((resolve, reject) => {
            commit(SITE_CHECKOUT_USER);
            commit('addLoading', {handle:'checkoutSite',name:'Checking out of Site'})

            let loginDetails = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                body: JSON.stringify(payload)
            };
                            
            fetch(Vue.prototype.$apiServer + 'site/' + payload.siteid + '/checkout', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                    commit('removeLoading', 'checkoutSite')
                        if (resp.result === 'Success') {
                            commit(SITE_CHECKINS_SUCCESS, resp);
                            resolve(resp)
                        } else {
                            commit(SITE_CHECKINS_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(SITE_CHECKINS_ERROR);
                    commit('removeLoading', 'checkoutSite')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })        
                }
            })
        })
    },
    [SITE_INSPECTION_REQUEST]: ({ commit, dispatch }, payload) => {
        //    window.console.log("New Site Payload: " + JSON.stringify(payload))
        return new Promise((resolve, reject) => {
            commit('addLoading', {handle:'siteinspection',name:'Submitting Site Inspection'})

            let loginDetails = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                body: JSON.stringify(payload.inspectionPayload)
            };
                            
            fetch(Vue.prototype.$apiServer + 'site/' + payload.siteid + '/inspection', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                    commit('removeLoading', 'siteinspection')
                        if (resp.result === 'Success') {
                            commit(SITE_INSPECTION_SUCCESS, resp);
                            resolve(resp)
                        } else {
                            commit(SITE_INSPECTION_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(SITE_INSPECTION_ERROR);
                    commit('removeLoading', 'siteinspection')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })        
                }
            })
        })
    },
    fetchSitePhotos: ({ commit, dispatch }, siteid) => {
        return new Promise((resolve, reject) => {
            commit(SITE_PHOTOS_REQUEST);
            commit('addLoading', { handle: 'fetchSitePhotos' + siteid, name: 'Fetching Site Photos' });

            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Auth-Token': Vue.prototype.$token
                }
            };

            fetch(Vue.prototype.$apiServer + `/site/${siteid}/photos`, requestOptions)
                .then(response => {
                    commit('removeLoading', 'fetchSitePhotos' + siteid);
                    if (response.ok) {
                        response.json().then(resp => {
                            if (resp.result === 'Success') {
                                commit(SITE_PHOTOS_SUCCESS, { siteid, photos: resp.payload });
                                resolve(resp.payload);
                            } else {
                                commit(SITE_PHOTOS_ERROR);
                                reject(resp.message || 'Failed to fetch photos');
                            }
                        });
                    } else {
                        commit(SITE_PHOTOS_ERROR);
                        if (response.status === 403) {
                            dispatch(AUTHTOKEN_LOGOUT);
                        }
                        response.json().then(err => {
                            reject(err.message || 'Failed to fetch photos');
                        }).catch(() => {
                            reject(`Server error: ${response.status}`);
                        });
                    }
                })
                .catch(error => {
                    commit('removeLoading', 'fetchSitePhotos' + siteid);
                    commit(SITE_PHOTOS_ERROR);
                    reject(error.message || 'Network error');
                });
        });
    },
    uploadSitePhoto: ({ commit, dispatch }, photo) => {
        // photo object: { id, siteid, file, tags, description, status }
        commit(SITE_PHOTO_UPLOAD_UPDATE, { id: photo.id, updates: { status: PHOTO_UPLOAD_STATUS.UPLOADING, error: null } });

        const formData = new FormData();
        formData.append('image', photo.file);
        formData.append('tags', photo.tags);
        if (photo.description) {
            formData.append('notes', photo.description);
        }

        const requestOptions = {
            method: 'POST',
            headers: {
                'X-Auth-Token': Vue.prototype.$token
                // Content-Type is set automatically by the browser for FormData
            },
            body: formData
        };

        return new Promise((resolve, reject) => {
            fetch(Vue.prototype.$apiServer + `site/${photo.siteid}/photo`, requestOptions)
                .then(response => {
                    if (response.ok) {
                        response.json().then(resp => {
                            if (resp.result === 'Success') {
                                commit(SITE_PHOTO_UPLOAD_UPDATE, { id: photo.id, updates: { status: PHOTO_UPLOAD_STATUS.SUCCESS } });
                                // Automatically remove successful uploads after a delay
                                setTimeout(() => {
                                    commit(SITE_PHOTO_UPLOAD_REMOVE, photo.id);
                                }, 5000);
                                resolve(resp);
                            } else {
                                commit(SITE_PHOTO_UPLOAD_UPDATE, { id: photo.id, updates: { status: PHOTO_UPLOAD_STATUS.ERROR, error: resp.message || 'Upload failed' } });
                                reject(resp.message || 'Upload failed');
                            }
                        });
                    } else {
                        if (response.status === 403) {
                            dispatch(AUTHTOKEN_LOGOUT);
                        }
                        response.json().then(err => {
                            commit(SITE_PHOTO_UPLOAD_UPDATE, { id: photo.id, updates: { status: PHOTO_UPLOAD_STATUS.ERROR, error: err.message || 'Upload failed' } });
                            reject(err.message || 'Upload failed');
                        }).catch(() => {
                            commit(SITE_PHOTO_UPLOAD_UPDATE, { id: photo.id, updates: { status: PHOTO_UPLOAD_STATUS.ERROR, error: `Server error: ${response.status}` } });
                            reject(`Server error: ${response.status}`);
                        });
                    }
                })
                .catch(error => {
                    commit(SITE_PHOTO_UPLOAD_UPDATE, { id: photo.id, updates: { status: PHOTO_UPLOAD_STATUS.ERROR, error: 'Network error' } });
                    reject(error.message || 'Network error');
                });
        });
    },
    addPhotoToUploadQueue: ({ commit, dispatch }, { siteid, file, tags, description }) => {
        const photo = {
            id: Date.now() + Math.random().toString(36).substr(2, 9),
            siteid,
            file,
            tags,
            description,
            status: PHOTO_UPLOAD_STATUS.PENDING,
            fileName: file.name,
            error: null
        };
        commit(SITE_PHOTO_UPLOAD_ADD, photo);
        dispatch('uploadSitePhoto', photo).catch(() => {
            // Error is already handled inside uploadSitePhoto by updating the photo status in the state
            // and the Footer component displays these errors.
            // We catch it here to prevent unhandled promise rejection warnings in the console/overlay.
        });
    },
    retryPhotoUpload: ({ state, dispatch }, photoId) => {
        const photo = state.photoUploads.find(p => p.id === photoId);
        if (photo) {
            dispatch('uploadSitePhoto', photo).catch(() => {
                // Error handled in action
            });
        }
    },
    removePhotoFromQueue: ({ commit }, photoId) => {
        commit(SITE_PHOTO_UPLOAD_REMOVE, photoId);
    },
};

const mutations = {
    [SITES_REQUEST]: state => {
        state.status = "loading";
    },
    [SITE_UPDATE]: state => {
        state.status = "updating";
    },
    [SITE_CREATE]: state => {
        state.sitecreatestatus = "creating";
    },
    [SITE_CREATE_SUCCESS]: state => {
        state.sitecreatestatus = "success";
    },
    [SITE_CREATE_ERROR]: state => {
        state.sitecreatestatus = "error";
    },
    [SITE_CREATE]: state => {
        state.sitecreatestatus = "creating";
    },
    [SITE_DELETE_REQUEST]: state => {
        state.sitedeletestatus = "deleting";
    },
    [SITE_DELETE_SUCCESS]: state => {
        state.sitedeletestatus = "success";
    },
    [SITE_DELETE_ERROR]: state => {
        state.sitedeletestatus = "error";
    },
    [SITE_PHOTOS_REQUEST]: state => {
        state.status = "loading";
    },
    [SITE_PHOTOS_SUCCESS]: (state, { siteid, photos }) => {
        state.status = "success";
        Vue.set(state.sitePhotos, siteid, photos);
    },
    [SITE_PHOTOS_ERROR]: state => {
        state.status = "error";
    },
    [SITES_SUCCESS]: (state, resp) => {
        state.status = "success";
        Vue.set(state, "sites", resp.payload);
    },
    [SITE_CHECKINS_REQUEST_ALL]: state => {
        state.status = "loading";
    },
    [SITE_CHECKINS_REQUEST_ALL_ERROR]: state => {
        state.status = "error";
    },
    [SITE_CHECKINS_REQUEST_ALL_SUCCESS]: (state, resp) => {
        state.status = "success";
        Vue.set(state, "sitecheckins", resp.payload);
    },
    [SITE_PUT_SUCCESS]: (state) => {
        state.siteupdatestatus = "success";
    //    Vue.set(state, "sites", resp);
    },
    [SITES_ERROR]: state => {
        state.status = "error";
    },
    [SITE_ACCESS_CREATE]: state => {
        state.siteaccessstatus = "creating";
    },
    [SITE_ACCESS_CREATE_ERROR]: state => {
        state.siteaccessstatus = "error";
    },
    [SITE_ACCESS_CREATE_SUCCESS]: state => {
        state.siteaccessstatus = "success";
    },
    [SITE_ACCESS_FORM]: state => {
        state.siteaccessformstatus = "creating";
    },
    [SITE_ACCESS_FORM_ERROR]: state => {
        state.siteaccessformstatus = "error";
    },
    [SITE_ACCESS_FORM_SUCCESS]: state => {
        state.siteaccessformstatus = "success";
    },
    [SITE_UPDATE_ERROR]: state => {
        state.siteupdatestatus = "error";
    },
    [SITES_SERVICES_REQUEST]: state => {
        state.siteservicesstatus = "loading";
    },
    [SITES_SERVICES_SUCCESS]: (state, payload) => {
        state.siteservicesstatus = "success";
        Vue.set(state.sites.find(site => site.siteid === payload.siteid), "services", payload.response);
    },
    [SITES_SERVICES_FAKE]: (state, payload) => {
        state.siteservicesstatus = "success";
        Vue.set(state.sites.find(site => site.siteid === payload.siteid), "services", payload.response);
    },
    [SITES_SERVICES_ERROR]: (state) => {
        state.siteservicesstatus = "error";
    },
    [SITE_CHECKINS_REQUEST]: state => {
        state.status = "loading";
    },
    [SITE_CHECKINS_ERROR]: state => {
        state.status = "error";
    },
    [SITE_CHECKINS_SUCCESS]: state => {
        state.status = "success";
    },
    [SITE_CHECKIN_USER]: state =>
    {
        state.status = "loading";
    }, 
    [SITE_CHECKOUT_USER]: state =>
    {
        state.status = "loading";
    },  
    [SITE_INSPECTION_REQUEST]: state =>
    {
        state.status = "loading";
    },  
    [SITE_INSPECTION_SUCCESS]: state =>
    {
        state.status = "success";
    },  
    [SITE_INSPECTION_ERROR]: state =>
    {
        state.status = "error";
    }, 
    [SITE_PHOTO_UPLOAD_ADD]: (state, photo) => {
        state.photoUploads.push(photo);
    },
    [SITE_PHOTO_UPLOAD_UPDATE]: (state, { id, updates }) => {
        const index = state.photoUploads.findIndex(p => p.id === id);
        if (index !== -1) {
            Vue.set(state.photoUploads, index, { ...state.photoUploads[index], ...updates });
        }
    },
    [SITE_PHOTO_UPLOAD_REMOVE]: (state, id) => {
        state.photoUploads = state.photoUploads.filter(p => p.id !== id);
    },
    [AUTHTOKEN_LOGOUT]: state => {
        state.sites = null;
    }
};
    
export default {
    state,
    getters,
    actions,
    mutations
};
